// Section2.jsx
import React from 'react';

const Section6 = () => {
  const benefits = [
    "Personalized mobile applications to fit your needs",
    "Expertise in both native and cross-platform development",
    "Scalable architecture prepared for growth",
    "Design that focuses on users to improve engagement",
    "Secure, dependable, and high-performance solutions",
    "Full development support from start to finish, with long-term maintenance"
  ];

  return (
    <section id="why-mean3" className="bg-white py-[20px] border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-[15px]">
          <h2 className="text-[24px] md:text-[38px] font-bold text-[#cd2122] leading-normal">Why Businesses Choose Mean3</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {benefits.map((text, index) => (
            <div key={index} className="flex gap-5 items-start bg-white p-7 rounded-2xl border border-gray-100 hover:border-[#cd2122]/30 transition-all group">
              <div className="w-8 h-8 rounded-full bg-[#cd2122]/10 text-[#cd2122] flex items-center justify-center font-bold flex-shrink-0 mt-1 group-hover:scale-110 transition-transform">
                {index + 1}
              </div>
              <p className="text-[#535353] text-[16px] leading-relaxed">{text}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <p className="text-[#535353] text-[16px] font-bold">Ready to turn your idea into a real mobile app?</p>
          <p className="text-[#535353] text-[16px] font-medium">Contact Mean3 today for a <a className='blue-link' href='/contact-mean3'>free consultation.</a></p>
        </div>
      </div>
    </section>
  );
};

export default Section6;